var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-nav",class:{ 'main-nav-fold': _vm.isCollapse }},[_c('ul',{staticClass:"menu-list"},_vm._l((_vm.modules),function(item){return _c('li',{key:item.key,class:[
        'menu-list__item',
        { disabled: item.status != 1, 'menu-list__item--active': item.id === _vm.currentModuleId },
      ],on:{"click":function($event){return _vm.handleClick(item)}}},[_c('MzIcon',{staticClass:"module-icon",style:({ fontSize: '32px' }),attrs:{"type":item.moduleIcon}}),_c('span',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(item.moduleName))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }